export const TAG_ID = 'ccwt';
